/* eslint-disable import-extensions/file-extension-required */
import React, { useEffect } from 'react';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';
import { ConditionalUfoHoldIgnore } from '@confluence/react-ufo-conditional-hold-ignore/entry-points/ConditionalUfoHoldIgnore.ts';
import { fg } from '@confluence/feature-gating';

import { useRovoCurrentConfigStoreActions } from '../store/RovoCurrentConfigStore.tsx';
import type { RovoProviderComponent } from '../shared-types/rovoConfigTypes.tsx';

export const RovoCurrentConfigProvider = ({
	provider,
}: {
	provider?: RovoProviderComponent;
}): React.JSX.Element | null => {
	const { resetConfiguration, setConfiguration } = useRovoCurrentConfigStoreActions();

	useEffect(() => {
		if (!provider) {
			resetConfiguration();
		}

		return () => {
			resetConfiguration();
		};
	}, [resetConfiguration, provider]);

	if (!provider) {
		return null;
	}

	const ActiveProviderComponent = provider;

	const content = (
		<ErrorBoundary attribution={Attribution.SMARTS}>
			<UFOSegment name="rovo-current-configuration-provider">
				<ActiveProviderComponent setConfiguration={setConfiguration} />
			</UFOSegment>
		</ErrorBoundary>
	);

	return fg('confluence_edit_page_conditional_ufohold_ignore_fg') ? (
		<ConditionalUfoHoldIgnore>{content}</ConditionalUfoHoldIgnore>
	) : (
		content
	);
};
